export enum RecurringInvoiceFrequency {
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  MonthlyLastDay = 'MONTHLY_LAST_DAY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}
